var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9998 6.59981L9.8998 0.699804C10.0831 0.516471 10.3165 0.424805 10.5998 0.424805C10.8831 0.424805 11.1165 0.516471 11.2998 0.699804C11.4831 0.883138 11.5748 1.11647 11.5748 1.3998C11.5748 1.68314 11.4831 1.91647 11.2998 2.09981L4.6998 8.69981C4.4998 8.89981 4.26647 8.99981 3.9998 8.99981C3.73314 8.99981 3.4998 8.89981 3.2998 8.69981L0.699804 6.09981C0.516471 5.91647 0.424805 5.68314 0.424805 5.3998C0.424805 5.11647 0.516471 4.88314 0.699804 4.6998C0.883138 4.51647 1.11647 4.42481 1.3998 4.42481C1.68314 4.42481 1.91647 4.51647 2.0998 4.6998L3.9998 6.59981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.40c74ee8252c87f5a62d5c03af126dc1.svg";
export { ForwardRef as ReactComponent };